module.exports = __webpack_public_path__ + "img/empty-turbine.82679b7d.svg";